export function getKeyFromParty(
  party: { type?: string; name?: string } | null | undefined,
) {
  if (!party) {
    return null;
  }
  if (party.type) {
    return party.type;
  }
  if (party.name) {
    return 'NAME';
  }
  return null;
}
